var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 7.49967C4.1665 7.9417 4.3421 8.36562 4.65466 8.67819C4.96722 8.99075 5.39114 9.16634 5.83317 9.16634C6.2752 9.16634 6.69912 8.99075 7.01168 8.67819C7.32424 8.36562 7.49984 7.9417 7.49984 7.49967C7.49984 7.05765 7.32424 6.63372 7.01168 6.32116C6.69912 6.0086 6.2752 5.83301 5.83317 5.83301C5.39114 5.83301 4.96722 6.0086 4.65466 6.32116C4.3421 6.63372 4.1665 7.05765 4.1665 7.49967Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 14.167V11.667H1.6665",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 6.66699V14.167",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6667H18.3333V10C18.3333 9.33696 18.0699 8.70107 17.6011 8.23223C17.1323 7.76339 16.4964 7.5 15.8333 7.5H10V11.6667Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBed;